export default "__VITE_ASSET__Fn06zqFV__"